<template>
  <div>
    <div>
      <el-button size="mini" icon="el-icon-plus" @click="toEdit(null)"
        >新增</el-button
      >
      <el-select
        v-model="filter.status"
        placeholder="启用状态"
        size="mini"
        class="w100"
      >
        <el-option
          v-for="item in status_options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        size="mini"
        v-model="filter.keyword"
        clearable
        @clear="search"
        placeholder="搜关键字"
        style="width: 300px"
        class="w300 input-with-select"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="search"
        ></el-button>
      </el-input>
    </div>
    <el-table :data="list_data.list" v-loading="loading" style="width: 100%">
      <el-table-column prop="id" label="ID" width="111"></el-table-column>
      <el-table-column prop="name" label="title" min-width="222"></el-table-column>
      <el-table-column prop="sort" label="排序" width="100">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sort"
              placeholder="请输入内容"
              @change="changeSort(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
      <el-table-column prop="status" label="启用" width="200">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status_bool"
            active-color="#13ce66"
            inactive-color="#aaaaaa"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="utime"
        label="修改时间"
        min-width="222"
        align="right"
      ></el-table-column>
      <el-table-column prop="ctime" label="操作" width="100">
        <template slot-scope="scope">
          <el-tag size="mini" class="pointer" @click="toEdit(scope.row)"
            >编辑</el-tag
          >
          <el-tag
            size="mini"
            type="info"
            class="pointer"
            @click="remove(scope.row.id)"
            >删除</el-tag
          >
        </template>
      </el-table-column>
    </el-table>
    <component :is="popName2" :item="editItem"></component>
  </div>
</template>
<script>
const edit = (resolve) => require(["@/pages/setting/aboutUs/_edit"], resolve);
export default {
  components: {
    edit,
  },
  data() {
    return {
      loading: false,
      popName2: null,
      editItem: null,
      filter: {
        keyword: "",
        status: 1,
        page: 1,
        size: 20,
      },
      list_data: {
        total: 0,
        size: 10,
        list: [],
      },
      systerm_brand_options: [],
      status_options: [
        { value: 1, label: "启用" },
        { value: 2, label: "下线" },
      ],
    };
  },
  methods: {
    toEdit(row = null) {
      this.editItem = row;
      this.popName2 = "edit";
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$http
        .post("/v1/pri/about-us/lists", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data;
          }
        });
    },
    changeSort(item) {
      this.$http
        .post("/v1/pri/about-us/sort", { id: item.id, sort: item.sort })
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.getList();
          }
        });
    },
    changeStatus(item) {
      this.$http
        .post("/v1/pri/about-us/change-status", {
          id: item.id,
          status: item.status_bool ? 1 : 2,
        })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    remove(id) {
      this.$confirm("删除属性", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在移除.." });
        this.$http
          .post("/v1/pri/about-us/remove", { id: id })
          .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: res.msg,
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.$store.commit("setLoading", { text: false });
          });
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/setting/aboutUs/_list.vue